import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatPrice, formatMiles, imgSrc } from "@/lib/api";

export const VehicleCard = ({ vehicle, index = 0 }) => {
  const sold = vehicle.status === "Sold";
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/inventory/${vehicle.id}`}
        data-testid={`vehicle-card-${vehicle.id}`}
        className="group block border border-white/10 bg-card transition-colors duration-500 hover:border-trx-blue/60"
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={imgSrc(vehicle.images?.[0])}
            alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
            loading="lazy"
            className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${sold ? "grayscale" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="absolute left-4 top-4 flex gap-2">
            {vehicle.featured && !sold && (
              <span className="bg-trx-blue px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white">
                Featured
              </span>
            )}
            {sold && (
              <span className="bg-white px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-black" data-testid="vehicle-sold-badge">
                Sold
              </span>
            )}
          </div>
          <span className="absolute bottom-4 right-4 bg-black/70 px-4 py-2 font-display text-xl font-bold text-white backdrop-blur-sm">
            {formatPrice(vehicle.price)}
          </span>
        </div>
        <div className="p-6">
          <div className="flex items-baseline justify-between gap-4">
            <h3 className="font-display text-xl font-bold tracking-tight text-white">
              {vehicle.year} {vehicle.make} {vehicle.model}
            </h3>
          </div>
          {vehicle.trim && <p className="mt-1 text-sm text-zinc-500">{vehicle.trim}</p>}
          <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4 text-xs uppercase tracking-wider">
            <span className="text-zinc-500">
              {vehicle.body_type && <span className="text-zinc-400">{vehicle.body_type} · </span>}
              {formatMiles(vehicle.mileage)}
            </span>
            <span className="font-semibold text-trx-blue opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              View Details →
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
